import useGlobalState from 'utils/global-state';
import PrivateInterviewSuccess from './private-success';
import PublicInterviewSuccessPage from './public-success';

export const InterviewSuccess = () => {
  const [{ userData }] = useGlobalState();
  if (userData) return <PrivateInterviewSuccess />;
  return <PublicInterviewSuccessPage />;
};
